import { Address } from "@/utils/types/types";
import { StripeCheckoutContact } from "@stripe/stripe-js";

type AddressCardProps = {
  address:
    | { name: string; address: Address; text?: string }
    | StripeCheckoutContact
    | null;
};

export default function AddressCard(props: AddressCardProps) {
  return (
    <div className="flex flex-wrap justify-between gap-x-5 gap-y-3 rounded-md border border-solid border-[#00000014] bg-[#F5F5F5] px-4 py-3">
      <p className="w-max text-[18px] font-medium leading-none">
        {props.address?.name}
      </p>
      <p className="flex w-max max-w-[100%] shrink-0 flex-wrap gap-2 leading-none text-[#636363]">
        <span className="w-max shrink-0 leading-none text-[#636363]">
          {props.address?.address?.line1}
        </span>
        {props.address?.address?.line2 && (
          <span className="w-max shrink-0 leading-none text-[#636363]">
            {props.address?.address?.line2}
          </span>
        )}
        <span className="w-max shrink-0 leading-none text-[#636363]">
          {[
            props.address?.address.city,
            [
              props.address?.address.state,
              props.address?.address.postal_code,
              props.address?.address.country,
            ].join(" "),
          ].join(", ")}
        </span>
      </p>
    </div>
  );
}
